import styled from 'styled-components'
import IMAGES from '../../images'
import { theme } from 'antd'

export const MainBannerWrapper = styled.div`
    // position: relative;
    // background-image: url(${IMAGES.BANNER_MAIN});
    // background-position: top left;
    // background-size: cover;
    // background-repeat: no-repeat;
    // //height: calc(100vh - 144px);  
    // height: calc(100vh + 16px);
    // width: 100%;
    //
    // .banner-person {
    //     position: absolute;
    //     right: 0;
    //     bottom: 0;
    //     height: 100%;
    //     @media only screen and (max-width: 1600px) {
    //         width: 60%;
    //         height: auto;
    //     }
    //     @media only screen and (max-width: 1200px) {
    //         width: 60%;
    //         height: auto;
    //     }
    //     @media only screen and (max-width: 992px) {
    //         width: 60%;
    //         height: auto;
    //     }
    //     @media only screen and (max-width: 768px) {
    //         width: 80%;
    //         height: auto;
    //     }
    //     @media only screen and (max-width: 576px) {
    //         width: 100%;
    //         height: auto;
    //     }
    // }
    //
    // @media only screen and (max-width: 1600px) {
    //     height: calc(90vh + 16px);
    // }
    // @media only screen and (max-width: 1200px) {
    //     height: 80vh;
    // }
    // @media only screen and (max-width: 992px) {
    //     height: 70vh;
    // }
    // @media only screen and (max-width: 768px) {
    //     height: 100vh;
    // }
    // @media only screen and (max-width: 767px) {
    //     height: 100vh;
    // }
`
export const MainBannerContent = styled.div`
`
export const MainBannerTextWrapper = styled.div`
    padding-top: 145px;
    @media only screen and (max-width: 1200px) {
        padding-top: 0;
    }
    @media only screen and (max-width: 992px) {
        padding-top: 0;
    }
    @media only screen and (max-width: 768px) {
        padding-top: 0;
    }
    @media only screen and (max-width: 576px) {
        padding-top: 16px;
        text-align: center;
    }
    
    .text-banner {
        object-fit: cover;
        width: 800px;
        @media only screen and (max-width: 1920px) {
            width: 800px;
            padding-top: 16px;
        }
        @media only screen and (max-width: 1600px) {
            width: 560px;
            padding-top: 16px;
        }
        @media only screen and (max-width: 1200px) {
            width: 560px;
            padding-top: 16px;
        }
        @media only screen and (max-width: 992px) {
            width: 480px;
            padding-top: 16px;
        }
        @media only screen and (max-width: 768px) {
            width: 480px;
            padding-top: 16px;
        }
        @media only screen and (max-width: 576px) {
            width: 310px;
            padding-top: 48px;            
        }
    }
`
export const MainBannerLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 32px;
    @media only screen and (max-width: 576px) {
        flex-direction: column;
    }

    .banner-vp {
        width: 240px;
    }

    .banner-care {
        width: 240px;
        @media only screen and (max-width: 576px) {
            padding-top: 48px;
        }
    }

    .divider {
        align-self: stretch;
        width: 1px;
        background-color: #ffffff;
        margin: 0 16px;
        @media only screen and (max-width: 576px) {
            display: none;
        }
    }
`
